import { React } from "react";
import {
  RightLayoutContainer,
  DetailFields,
  GroupTitle,
  PageTitleComp,
} from "../../styledElements";
import {
  Button,
  Row,
  Col,
  Form,
  Input,
  PageHeader,
  Upload,
  message,
  Checkbox
} from "antd";
import "antd/dist/antd.css";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { HaberForm } from "../../styledElements";
import { useLocation, useNavigate } from "react-router-dom";
import PreparingUploadOrders from "./preparingUploadOrders";
import { useEffect, useState } from "react";
import { newUploadOrders, uploadFile } from "../../../Services/uploadServices";
import {
  defaultUploadFormat,
  getUploadFormats,
} from "../../../Services/settingsServices";
import { getUserEmailId } from "../../../Services/localStorageServices";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import { getBulkURL, getImageURL } from "../../../Services/deckleMatchServices";
import { getWorkflowSettings } from "../../../Services/workFlowSettingsServices";

const { Dragger } = Upload;

const UploadPO = (props) => {
  const location = useLocation();
  const [uploadFormat, setUploadFormat] = useState([]);
  const [defaultFormat, setDefaultFormat] = useState(null);
  const [fileList, setFileList] = useState([]);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [otherFormats, setOtherFormats] = useState(false);
  const [actionToaster, setActionToaster] = useState({
    error: "",
    msg: "",
  });
  const [visibleToaster, setVisibleToaster] = useState(false);
  const [orderManagementSettings,setOrderManagementSetting] = useState(JSON.parse(localStorage.getItem("order-management-settings")));
  const uploadFormatsWithBQ = ["format_7"];
  const [isChecked, setIsChecked] = useState(false);

  // const fileUploadData = {
  //   name: "file",
  //   multiple: false,
  //   maxCount: 1,
  //   listType: "picture",
  //   accept: "text/csv,application/vnd.ms-excel",
  //   beforeUpload: () => {
  //     return false;
  //   },
  //   // action: ' http://localhost:3000/api/upload_file',
  //   onChange(info) {
  //     const { status } = info.file;
  //     if (status !== "uploading") {
  //       // console.log(info.file, info.fileList);
  //       if (status === "removed") setUploadedFile(null);
  //       else setUploadedFile(info.fileList[0]["originFileObj"]);
  //     } else if (status)
  //       if (status === "done") {
  //         message.success(`${info.file.name} file uploaded successfully.`);
  //       } else if (status === "error") {
  //         message.error(`${info.file.name} file upload failed.`);
  //       }
  //   },
  //   onDrop(e) {
  //     console.log("Dropped files", e.dataTransfer.files);
  //   },
  // };
  const fileUploadData = {
    name: "file",
    multiple: false,
    maxCount: 1,
    listType: "picture",
    accept: ".csv,.xls,.xlsx",
    beforeUpload: () => false, // prevent auto upload
    fileList: fileList, // controlled file list
    onChange(info) {
      const { file } = info;
      const ext = file?.name?.split(".").pop().toLowerCase();

      // Block SVG or invalid files
      if (ext !== "csv" && ext !== "xls" && ext !== "xlsx") {
        setActionToaster({
          error: true,
          msg: "Invalid file type. Only CSV, XLS and XLSX files are allowed.",
        });
        setVisibleToaster(true);
        setTimeout(() => setVisibleToaster(false), 3000);

        // Remove blocked file from UI
        setFileList(prev => prev.filter(f => f.uid !== file.uid));
        return;
      }

      if (info.file.status !== "uploading") {
        setUploadedFile(info?.fileList[0]?.originFileObj);
        setFileList([file]); // keep only the latest file
      }
    },
    onRemove(file) {
      // Fully clear the state
      setUploadedFile(null);
      setFileList([]);
      return false; // Prevent AntD default remove handling
    },
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
    },
  };

  const history = useNavigate();

  useEffect(() => {
  (async ()=>{
    try{
      const orderMangSettings = await getWorkflowSettings("order_management");
      console.log(orderMangSettings?.data);
      setOrderManagementSetting(orderMangSettings?.data);
    }
    catch(e){
      console.log(e);
    }
  })();
},[]);

useEffect(() => {
  (async () => {
    try {
      if (location.state?.error || location.state?.isFileEmpty) {
        setActionToaster({
          error: true,
          msg:
            location.state?.fileEmptyKey === "no data"
              ? location.state.msg
              : "Format is incorrect. Please upload correct format",
        });
        showToaster();
      }

      const formats = await getUploadFormats();

      if (orderManagementSettings && !formats.data.error) {
        // Fetch urls for "others"
        const othersWithUrls = await Promise.all(
          formats.data.data.others.map(async (item) => {
            const url = await getImageURL({ bucket_key: item.template,operation:"download" });
            return { ...item, template: url };
          })
        );

        let defaultFormat;
        if(orderManagementSettings?.fetch_balance_quantity?.value && !uploadFormatsWithBQ.includes(formats.data.data.default.name))
          defaultFormat = formats.data.data.others.filter(format=>format.name == "format_7")[0];
        else
          defaultFormat = formats.data.data.default;

        // Fetch url for default
        const defaultURL = await getImageURL({
          bucket_key: defaultFormat.template,
          operation:"download"
        });
        defaultFormat.template = defaultURL;

        // Update state
        setDefaultFormat(defaultFormat);
        setUploadFormat(othersWithUrls.filter(format => {
          if(orderManagementSettings?.fetch_balance_quantity?.value)
          {
            return uploadFormatsWithBQ.includes(format.name) && defaultFormat.name !==format.name;
          }
          else
          {
            return !uploadFormatsWithBQ.includes(format.name);
          }
        }));
      }
    } catch (error) {
      console.error(error);
    }
  })();
}, [location.state,orderManagementSettings]);




  const showToaster = () => {
    setVisibleToaster(true);
    setTimeout(() => setVisibleToaster(false), 3000);
  };

  const uploadOrders = async () => {
    const userEmailId = getUserEmailId();
    // await uploadFile(uploadedFile);
    const res = await getImageURL({ bucket_key: `${userEmailId}/${uploadedFile.name}`,operation:"upload"});
    await newUploadOrders(res,uploadedFile);
    history("../order-records/preparing-upload-orders", {
      state: {
        action: `${userEmailId}/${uploadedFile.name}`,
        format: defaultFormat?.name,
        isBalancedQuantityFetched: orderManagementSettings?.fetch_balance_quantity?.value,
        checkBoxValue: isChecked
      },
    });
  };

  const GoBackRouteChange = () => {
    history("../order-records");
  };

  const showOtherFormats = () => {
    setOtherFormats(!otherFormats);
  };

  const markAsDefault = async (uploadFormat) => {
    let body = {
      name: uploadFormat.name,
    };
    const response = await defaultUploadFormat(body);

    if (!response.error) {
      const formats = await getUploadFormats();
      if (!formats.data.error) {
        setDefaultFormat(formats.data.data.default);
        setUploadFormat(formats.data.data.others);
        setActionToaster({
          error: false,
          msg: "Default upload format is changed successfully",
        });
        showToaster();
      }
    }
  };

  const onCheckboxChange = (value) => {
    setIsChecked(value);
  }

  return (
    <RightLayoutContainer>
      <PageTitleComp className="marginRightAdg">
        <PageHeader
          ghost={false}
          onBack={() => history("../order-records")}
          title="Upload PO and SO"
          extra={[
            <Button
              key="1"
              className="themeBtn noBg"
              onClick={GoBackRouteChange}
            >
              <Iconmoon icon="wrong" size={14} color="#EA655B" />
              Cancel
            </Button>,
            <Button
              key="1"
              className="themeBtn"
              onClick={uploadOrders}
              disabled={uploadedFile ? false : true}
            >
              <Iconmoon icon="move-right" size={14} color="#ffffff" />
              Next
            </Button>,
          ]}
        ></PageHeader>
      </PageTitleComp>
      <DetailFields>
        {/* <HaberForm> */}
        <div className="groupDetailWrap">
          <Form name="basic" autoComplete="off" className="haberLogin">
            <Row gutter={[16, 16]} className="groupForm lastGroup">
              <Col span={8}>
                <GroupTitle>
                  <h2>Upload File</h2>
                  <p>
                  You can upload PO/ SO in valid format. <br></br>
                    You need to fill your orders data in same format and{" "}
                    <br></br>
                    upload the file to add orders in Kaiznn
                  </p>
                  {/* <a style={{"color":"#EA655B"}}> Download excel format</a> */}
                </GroupTitle>
              </Col>
              <Col span={16}>
                <Row className="centerAlign">
                  <Col span={12}>
                    <div className="boxFieldTitle">
                      <label>{`Default Upload Format : ${
                        defaultFormat?.description
                          ? defaultFormat?.description
                          : ""
                      }`}</label>
                      {defaultFormat?.name==='format_5'||defaultFormat?.name==='format_6'?<p>Upload PO/SO details in the attached template </p>:<p>Upload PO details in the attached template </p>}
                      <a
                        href={
                          defaultFormat?.template
                            ? `${defaultFormat.template}`
                            : "#"
                        }
                        style={{ color: "#EA655B" }}
                      >
                        {" "}
                        Download template
                      </a>
                    </div>
                  </Col>
                  <Col span={12} className="blockBreak">
                    <div
                      className="boxFormType csv-file"
                      style={{ marginBottom: "0" }}
                    >
                      <Dragger 
                      {...fileUploadData}  
                      disabled={!defaultFormat}>
                        <p className="ant-upload-drag-icon">
                          <Iconmoon
                            icon="upload-image"
                            size={18}
                            color="#A19F9D"
                          />{" "}
                        </p>
                        <p className="ant-upload-text">
                          <span>Click to add</span> or drag and drop
                        </p>
                        <p className="ant-upload-hint">
                          CSV or Excel (max. 1 MB)
                        </p>
                      </Dragger>
                      {orderManagementSettings?.fetch_balance_quantity?.value && (
                        <HaberForm>
                        <Checkbox
                          onChange={(e) => onCheckboxChange(e.target.checked)}
                          checked={isChecked}
                          className="logCheck"
                          style={{marginTop:"5px"}}
                        >
                          <span
                            style={{
                              fontSize: "14px",
                              color: "black",
                              fontFamily: "var(--sf-pro-display-m)",
                              fontStyle: "normal",
                            }}
                          >
                            Keep only uploaded orders and move the rest to completed state
                          </span>
                        </Checkbox>
                      </HaberForm>)}
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
            {uploadFormat?.length ? (
              <Row gutter={[16, 16]} className="lastGroup">
                <Col span={8}></Col>
                <Col span={16}>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <a
                          onClick={showOtherFormats}
                          style={{
                            color: "#EA655B",
                            textDecoration: "underline",
                          }}
                        >
                          {" "}
                          View Other Formats
                        </a>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            ) : null}
            {otherFormats && uploadFormat?.length
              ? uploadFormat.map((values, index) => (
                  <Row gutter={[16, 16]} className="groupForm lastGroup">
                    <Col span={8}></Col>
                    <Col span={16}>
                      <Row className="centerAlign">
                        <Col span={12}>
                          <div className="boxFieldTitle">
                            <label>{`Upload Format ${index + 1} : ${
                              values?.description
                            }`}</label>
                            {values.name==='format_5'||values.name==='format_6'?<p>Upload PO/SO details in the attached template </p>:<p>Upload PO details in the attached template </p>}
                            <a
                              href={
                                values?.template
                                  ? `${values.template}`
                                  : "#"
                              }
                              style={{ color: "#EA655B" }}
                            >
                              {" "}
                              Download template
                            </a>
                            <a
                              onClick={() => markAsDefault(values)}
                              style={{ color: "#EA655B", marginLeft: "30px" }}
                            >
                              {" "}
                              Mark as default
                            </a>
                          </div>
                        </Col>
                        <Col span={12} className="blockBreak">
                          <div
                            className="boxFormType csv-file"
                            style={{ marginBottom: "0" }}
                          >
                            {/* <Dragger {...fileUploadData} listType="picture" accept="'text/csv,application/vnd.ms-excel'" beforeUpload={() => false}> */}
                            {/* <p className="ant-upload-drag-icon"><Iconmoon icon="upload-image" size={18} color="#A19F9D" /> </p> */}
                            {/* <p className="ant-upload-text"><span>Click to add</span> or drag and drop</p> */}
                            {/* <p className="ant-upload-hint">CSV or Excel (max. 1 MB)</p> */}
                            {/* </Dragger> */}
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                ))
              : null}
            {/* <div className="buttonRight" style={{ marginTop: "20px" }}>
                                <Form.Item>
                                    <Button className="themeBtn">Upload PO</Button>
                                </Form.Item>
                            </div> */}
          </Form>
        </div>
        {/* </HaberForm> */}
      </DetailFields>
      {visibleToaster && !actionToaster.error && (
        <AlertContainer
          color="green toaster"
          icon={alertGreen}
          msg={actionToaster.msg}
        />
      )}
      {visibleToaster && actionToaster.error && (
        <AlertContainer
          color="red toaster"
          icon={alertRed}
          msg={actionToaster.msg}
        />
      )}
    </RightLayoutContainer>
  );
};

export default UploadPO;
